module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "jumbotron"
  }, [_c('h2', [_vm._v("About")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "lead"
  }, [_vm._v("Currently only one stream can be created at a time due to the limitation of the Stream API, but multiple users can view the ongoing stream and it's details.")]), _vm._v(" "), _c('h4', [_vm._v("Select your stream options")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-lg-6 col-md-6 col-sm-12"
  }, [_c('label', {
    attrs: {
      "for": "language"
    }
  }, [_vm._v("Language")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.languageSelect),
      expression: "languageSelect"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "language",
      "id": "language"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.languageSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "null"
    }
  }, [_vm._v("---")]), _vm._v(" "), _vm._l((_vm.languages), function(l, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": l.value
      }
    }, [_vm._v(_vm._s(l.name) + "\n                    ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-lg-6 col-md-6 col-sm-12"
  }, [_c('label', {
    attrs: {
      "for": "track"
    }
  }, [_vm._v("Track")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "track",
      "id": "track",
      "placeholder": "Words or phrases to track"
    },
    domProps: {
      "value": _vm.trackString
    },
    on: {
      "input": _vm.setTrackString,
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.saveOptions($event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !_vm.canSaveOptions
    },
    on: {
      "click": _vm.saveOptions
    }
  }, [_vm._v("Save Settings")])])])]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "lead"
  }, [_vm._v("Twitter Stream is a full stack JavaScript application using the Twitter streaming API to filter custom tweets selected by a user. A user can filter tweets based on selected languages, certain words or phrases, hashtags, user accounts, locations and other options. Check out "), _c('a', {
    attrs: {
      "href": "https://twitter.com/search-advanced",
      "target": "_blank"
    }
  }, [_vm._v("Twitter's advanced search")]), _vm._v(" for a full example of these search parameters.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row marketing"
  }, [_c('h2', {
    staticClass: "col-lg-12"
  }, [_vm._v("About Stream Options")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('h4', [_vm._v("Track")]), _vm._v(" "), _c('p', [_vm._v("Keywords to track. Phrases of keywords are specified by a comma-separated list.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8c588e94","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Options.vue
// module id = 27
// module chunks = 0